import { render, staticRenderFns } from "./ot-claim-details.vue?vue&type=template&id=68e85261&scoped=true&"
import script from "./ot-claim-details.vue?vue&type=script&lang=ts&"
export * from "./ot-claim-details.vue?vue&type=script&lang=ts&"
import style0 from "./ot-claim-details.vue?vue&type=style&index=0&id=68e85261&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e85261",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
